<template>
  <nav class="postsAction" v-show="selected.length > 0">
    <ul class="postsAction__Select">
      <li class="postsAction__SelectReset">
        <label for="selectAll">
          <icon v-show="selectAll === true" name="minus-square"></icon>
          <icon v-show="selectAll === false" name="plus-square"></icon>
        </label>
      </li>
      <li class="postsAction__SelectNumber">
        <strong>{{ this.selected.length }}</strong> items selected
      </li>
    </ul>

    <ul class="postsAction__Edit">
      <li>
        <button @click="disable()">
          <template v-if="disableLabel.toLowerCase() === 'enable'"><icon name="eye"></icon> Enable</template>
          <template v-else><icon name="eye-slash"></icon> Disable</template>
        </button>
      </li>
      <li v-if="searchParams !== undefined">
        <button @click="toggleFeatured()">
          <icon :name="feature.name" :weight="feature.weight"></icon> {{ feature.label }}
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
import EventBus from '@/bus.js'

export default {
  props: ['type', 'selected', 'selectAll', 'items', 'searchParams'],
  name: 'Actions',
  data() {
    return {
      featureStates: [],
    }
  },
  methods: {
    // Update featured states based on currently selected items
    setFeaturedStates() {
      this.featureStates = []
      this.selected.forEach((id) => {
        const index = this.items.findIndex((x) => x.id === id)
        this.featureStates.push(this.items[index].is_featured)
      })
    },
    // Actions
    disable() {
      if (confirm(`Are you sure you want to ${this.disableLabel.toLowerCase()} the selected resources?`)) {
        EventBus.$emit('actionDisable', JSON.stringify(this.selected))
      }
    },
    toggleFeatured() {
      EventBus.$emit('actionFeature', JSON.stringify(this.selected))
      this.setFeaturedStates()
    },
  },
  watch: {
    selected() {
      if (this.searchParams !== undefined) this.setFeaturedStates()
    },
  },
  computed: {
    feature() {
      if (this.featureStates.every((v) => v === false)) {
        return {
          name: 'star',
          weight: 'solid',
          label: 'Set featured',
        }
      } else if (this.featureStates.every((v) => v === true)) {
        return {
          name: 'star',
          weight: 'light',
          label: 'Remove featured',
        }
      } else {
        return {
          name: 'star-half',
          weight: 'light',
          label: 'Toggle featured',
        }
      }
    },
    disableLabel() {
      if (this.$route.query.search !== undefined && JSON.parse(this.$route.query.search).status === 'disabled') {
        return 'Enable'
      } else {
        return 'Disable'
      }
    },
  },
}
</script>
